import React from 'react';
import { MapPin, Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const CitiesSection = () => {
  const countries = [
    {
      country: "France",
      flag: "🇫🇷",
      cities: [
        "Paris", "Lyon", "Marseille", "Toulouse", "Bordeaux", "Lille",
        "Nantes", "Strasbourg", "Montpellier", "Nice", "Rennes", "Reims",
        "Toulon", "Grenoble", "Dijon", "Angers", "Nîmes", "Saint-Étienne"
      ]
    },
    {
      country: "Belgique",
      flag: "🇧🇪",
      cities: [
        "Bruxelles", "Anvers", "Liège", "Gand", "Charleroi", "Namur",
        "Bruges", "Mons", "Louvain", "Schaerbeek"
      ]
    },
    {
      country: "Suisse",
      flag: "🇨🇭",
      cities: [
        "Genève", "Lausanne", "Zurich", "Berne", "Bâle", "Fribourg",
        "Neuchâtel", "Sion", "Montreux", "Lugano"
      ]
    },
    {
      country: "Canada",
      flag: "🇨🇦",
      cities: [
        "Montréal", "Québec", "Toronto", "Ottawa", "Laval", "Gatineau",
        "Longueuil", "Sherbrooke", "Trois-Rivières", "Saguenay"
      ]
    },
    {
      country: "Afrique",
      flag: "🌍",
      cities: [
        "Dakar", "Abidjan", "Casablanca", "Tunis", "Douala", "Kinshasa",
        "Libreville", "Bamako", "Conakry", "Lomé", "Cotonou", "Ouagadougou"
      ]
    },
    {
      country: "DOM-TOM",
      flag: "🏝️",
      cities: [
        "Guadeloupe", "Martinique", "Guyane", "Réunion", "Mayotte",
        "Nouvelle-Calédonie", "Polynésie", "Saint-Martin"
      ]
    }
  ];

  return (
    <section className="py-16 sm:py-28 bg-gradient-to-b from-gray-950 via-black to-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Intervention Mondiale
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 px-2">
            Le Grand Marabout intervient <span className="text-amber-500">partout dans le monde</span>
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-4xl mx-auto leading-relaxed px-2">
            Que vous soyez en France, Belgique, Suisse, Canada, Afrique ou dans les DOM-TOM, 
            le marabout africain réalise des rituels de retour affectif efficaces à distance. 
            L'énergie spirituelle ne connaît pas de frontières.
          </p>
        </div>

        {/* Countries Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {countries.map((country, index) => (
            <article key={index} className="bg-gray-900/50 border border-amber-500/10 rounded-2xl p-6 sm:p-8 hover:border-amber-500/30 transition-all duration-300">
              <div className="flex items-center space-x-3 mb-6">
                <span className="text-3xl">{country.flag}</span>
                <h3 className="text-xl sm:text-2xl font-bold text-white">
                  Marabout {country.country}
                </h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {country.cities.map((city, cityIndex) => (
                  <span
                    key={cityIndex}
                    className="px-3 py-1 bg-gray-800/50 border border-amber-500/10 rounded-full text-gray-400 text-xs sm:text-sm hover:text-amber-500 hover:border-amber-500/30 transition-colors"
                  >
                    <MapPin className="w-3 h-3 inline mr-1" />
                    {city}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        {/* SEO Text */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-sm sm:text-base max-w-4xl mx-auto leading-relaxed mb-8">
            Le <strong className="text-amber-500">grand marabout africain</strong> est le 
            spécialiste du <strong>retour affectif à Paris</strong>, <strong>marabout Lyon</strong>, 
            <strong>marabout Marseille</strong>, <strong>marabout Bruxelles</strong>, <strong>marabout Genève</strong>, 
            <strong>marabout Montréal</strong> et dans toutes les villes francophones. 
            Les rituels de <strong>retour de l'être aimé</strong> et d'<strong>envoûtement amoureux</strong> 
            fonctionnent à distance avec la même puissance.
          </p>
          <a
            href={contactInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-bold text-base sm:text-lg rounded-full transition-all duration-300 hover:scale-105"
          >
            <MessageCircle className="w-5 h-5 mr-3" />
            Contactez le marabout sur WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default CitiesSection;
